<template>
	<div class="index_header no-trans" v-loading="loading" @keydown.esc="close_mobile_menu" @keydown.tab="trap_menu_focus">
        <div class="mobile_header" v-if="mobile_view">
            <a href="/home" class="mobile_logo" @click.prevent="handle_home">
                <img v-if="vuex_setting.site_logo" :src="vuex_setting.site_logo" alt="法律裁判点评网">
                <span v-else>法律裁判点评网</span>
            </a>
            <button type="button" class="mobile_user" aria-label="会员中心" @click="handle_user"><i class="el-icon-user"></i></button>
            <button ref="mobile_menu_button" type="button" class="mobile_menu" :aria-expanded="String(mobile_menu_open)" aria-controls="mobile_site_nav" :aria-label="mobile_menu_open ? '收起网站导航' : '展开网站导航'" @click="mobile_menu_open = !mobile_menu_open"><i :class="mobile_menu_open ? 'el-icon-close' : 'el-icon-menu'"></i></button>
        </div>
        <div v-if="mobile_view && mobile_menu_open" class="mobile_nav_mask" @click="close_mobile_menu" aria-hidden="true"></div>
        <nav id="mobile_site_nav" ref="mobile_site_nav" v-if="mobile_view && mobile_menu_open" class="mobile_nav" aria-label="网站导航" @click="handle_mobile_nav_click">
            <div class="mobile_nav_links">
            <template v-for="(item, index) in tab_list">
                <details v-if="item.list.length" :key="index" :open="item.path_ac.indexOf(tab_ac) > -1" :class="{ 'nav_group_active': item.path_ac.indexOf(tab_ac) > -1 }">
                    <summary><i :class="mobile_nav_icon(item.path)" aria-hidden="true"></i><span>{{ item.title }}</span><i class="nav_chevron el-icon-arrow-down" aria-hidden="true"></i></summary>
                    <div class="mobile_subnav">
                    <a v-for="(child, childIndex) in item.list" :key="childIndex" :href="child.path" :aria-current="$route.fullPath === child.path || $route.path === child.path ? 'page' : null" @click.prevent="handle_tab(child)">{{ child.title }}<i class="el-icon-arrow-right" aria-hidden="true"></i></a>
                    </div>
                </details>
                <a v-else :key="index" class="mobile_nav_direct" :href="item.path" :aria-current="item.path_ac.indexOf(tab_ac) > -1 ? 'page' : null" @click.prevent="handle_path(item)"><i :class="mobile_nav_icon(item.path)" aria-hidden="true"></i><span>{{ item.title }}</span></a>
            </template>
            </div>
            <div class="mobile_nav_account">
            <a href="/login" v-if="!vuex_user.name" @click.prevent="handle_logo"><i class="el-icon-user" aria-hidden="true"></i>登录</a>
            <a href="/enroll" v-if="!vuex_user.name" @click.prevent="handle_enroll"><i class="el-icon-edit-outline" aria-hidden="true"></i>注册</a>
            <a v-for="(item, index) in hyzx_list" v-if="vuex_user.name" :key="'user' + index" :href="item.path || '#'" @click.prevent="handle_hyzx(item)">{{ item.title }}</a>
            </div>
        </nav>
		 <div class="header1_box">
            <div class="header1">
                <div class="lefts" v-if="!vuex_user.name">
                    <div class="l_text1" @click="handle_logo">
                        您好，请登录
                    </div>
                    <div class="l_text2" @click="handle_enroll">
                        注册
                    </div>
                </div>
                <div class="lefts" v-if="vuex_user.name">        
                    <div class="l_text1" @click="handle_user">
                        您好，{{ vuex_user.name }}
                    </div>            
                </div>
                <div class="rights">
                    <div class="r_text1" @click="handle_home">首页</div>
                    <div class="r_text2">
                        <el-dropdown  @command="handle_hyzx">
                            <span class="el-dropdown-link" >
                                会员中心<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item  :command="item" v-for="(item,index) in hyzx_list" :key="index">{{ item.title }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="r_text2">
                        <el-dropdown  @command="handle_ksfb">
                            <span class="el-dropdown-link" >
                                快速发布<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item  :command="item" v-for="(item,index) in ksfb_list" :key="index">{{ item.title }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="r_text2">
                        <el-dropdown  @command="handle_wzdh">
                            <span class="el-dropdown-link" >
                                网站导航<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item  :command="item" v-for="(item,index) in wzdh_list" :key="index">{{ item.title }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    
                </div>
            </div>
          
         </div>
         <div class="header2_box">
                <div class="header2_top">
                    <div class="lefts">
                        <div class="logos">
                            <img :src="vuex_setting.site_logo" alt=""  @click="handle_home">
                            
                        </div>
                    </div>
                    <div class="const">
                        <!-- <div class="seach_box">
                            <div class="inputs">
                                <input type="text" placeholder="请输入关键字" v-model="keyword">
                            </div>
                            <div class="btns" @click="handle_keyword">
                                <img src="@/assets/img/component/header/seach.png" alt="" >
                                搜索
                            </div>
                        </div> -->
                    </div>
                    <div class="rights">
                        <div class="r_phones">
                            <div class="imgs">
                                <img src="@/assets/img/component/header/phone.png" alt="">
                            </div>
                            <div class="r_text_box">
                                <div class="text1">客服热线</div>
                                <div class="text2">{{ vuex_setting.site_tel||'' }}</div>
                            </div>
                        </div>
                        <div class="kf_btns">
                            <img src="@/assets/img/component/header/kf_icon.png" alt="">
                            在线客服
                        </div>
                    </div>
                </div>
                <div class="header2_bom">
                    <div class="header2">
                        <div class="tab_list" v-for="(item,index) in tab_list" :key="index">
                            <!-- tab_item1_ac -->
                             <!-- {{ tab_ac }} -->
                            <div class="tab_item1" :class="{tab_item1_ac:item.path_ac.indexOf(tab_ac)>-1}" v-if="item.list.length==0" @click="handle_path(item)">
                                {{ item.title }}
                                <div class="borders"></div>
                            </div>
                            <div class="tab_item2" :class="{tab_item1_ac:item.path_ac.indexOf(tab_ac)>-1}" v-if="item.list.length>0">
                                <el-dropdown  @command="handle_tab">
                                    <span class="el-dropdown-link" >
                                        <!-- <div class=""> -->
                                            <div>
                                                {{ item.title }}
                                                <div class="borders"></div>
                                            </div>
                                            <div>
                                                <i class="el-icon-arrow-down el-icon--right"></i>
                                            </div>
                                        <!-- </div> -->
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item  :command="items" v-for="(items,indexs) in item.list" :key="indexs">{{ items.title }}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex'
	export default {
		components: {

		},
		name: "index",
		data() {
			return {
                loading:false,
                mobile_menu_open:false,
                // 个人中心：个人信息、我的订单、我的点评、我的委托
                // 会员中心菜单列表
                hyzx_list:[
                    {
                        title:'个人信息',
                        path:'/user_grzx'
                    },
                    {
                        title:'我的订单',
                        path:'/user_order'
                    },
                    {
                        title:'我的点评',
                        path:'/user_dp'
                    },
                    {
                        title:'我的委托',
                        path:'/user_wt'
                    },
                    {
                        title:'退出登录',
                        path:''
                    },
                ],
                //快速发布
                // 快速发布：发布案例点评、发布委托
                ksfb_list:[
                    {
                        title:'发布案例点评',
                        path:'/release_index'
                    },
                    {
                        title:'发布委托',
                        path:'/enterprise_list'
                    }
                ],
                //网站导航
                // 网站导航：帮助中心
                wzdh_list:[
                    {
                        title:'帮助中心',
                        path:'/index'
                    }
                ],
                tab_ac:'',
                tab_list:[
                    {
                        title:'首页',
                        path:'/home',
                        list:[],
                        path_ac:[
                            'home',
                        ]
                    },
                    {
                        title:'法律咨询',
                        path:'/online',
                        list:[
                            {
                                title:'在线咨询',
                                path:'/online'
                            },
                            {
                                title:'预约律师',
                                path:'/lawyer_list'
                            },
                        ],
                        path_ac:[
                            'online',
                            'online_quitting',
                            'lawyer_list',
                            'lawyer_detial',
                            'lawyer_sever_list',
                        ]
                    },
                    {
                        title:'裁判点评',
                        path:'/comments_list',
                        list:[
                            {
                                title:'裁判点评',
                                path:'/comments_list'
                            },
                            {
                                title:'案例库',
                                path:'/case_list'
                            },
                            {
                                title:'案例发布',
                                path:'/release_index'
                            }
                        ],
                        path_ac:[
                            'comments_list',
                            'comments_detial',
                            'case_list',
                            'case_detial',
                            'release_index',
                            
                        ]
                    },
                    {
                        title:'案源广场',
                        path:'/square_list',
                        list:[],
                        path_ac:[
                            'square_list',
                            'square_detial',
                        ]
                       
                    },
                    {
                        title:'企业法务',
                        path:'/enterprise_list',
                        list:[],
                        path_ac:[
                            'enterprise_list',
                            'enterprise_detial',
                        ]
                    },
                    {
                        title:'个人法务',
                        path:'/individual_list',
                        list:[],
                        path_ac:[
                            'individual_list',
                            'individual_detial',
                        ]
                    },
                    {
                        title:'法律讲堂',
                        path:'/Classroom',
                        list:[
                            {
                                title:'法律讲堂',
                                path:'/Classroom'
                            },
                            {
                                title:'法界热点',
                                path:'/hot_spot'
                            },
                            {
                                title:'人才招聘',
                                path:'/talent_acquisition'
                            }
                        ],
                        path_ac:[
                            'Classroom',
                            'Classroom_list_video',
                            'Classroom_list_video_detial',
                            'Classroom_list_text',
                            'Classroom_list_text_detial',
                            'hot_spot',
                            'hot_spot_type',
                            'hot_spot_type_detial',
                            'talent_acquisition',
                            'talent_acquisition_detial',
                        ]
                    },
                    {
                        title:'招商加盟',
                        path:'/index',
                        list:[
                            {
                                title:'招商加盟',
                                path:'/Merchants'
                            },
                            {
                                title:'区域合伙人',
                                path:'/Regional_Partner'
                            }
                        ],
                        path_ac:[
                            'Merchants',
                            'Regional_Partner',
                        ]
                    },
                    {
                        title:'更多服务',
                        path:'/index',
                        list:[
                            {
                                title:'诉讼费计算器',
                                path:'/service?type=1'
                            },
                            {
                                title:'服务报价计算器',
                                path:'/service?type=2'
                            },
                            {
                                title:'点评服务费',
                                path:'/service?type=3'
                            },
                            {
                                title:'积分商城',
                                path:'/shop'
                            }
                        ],
                        path_ac:[
                            'service',
                            'shop',
                        ]
                    }
                    
                ],
                keyword:'',
			}
		},
		computed: {
			...mapState(['vuex_setting','vuex_user'])
		},
		watch: {
            mobile_menu_open(open) {
                if (open && this.mobile_view) {
                    this.menu_scroll_restore = { body: document.body.style.overflow, html: document.documentElement.style.overflow }
                    document.body.style.overflow = 'hidden'
                    document.documentElement.style.overflow = 'hidden'
                } else this.restore_menu_scroll()
            },
            mobile_view(mobile) {
                if (!mobile) this.mobile_menu_open = false
            },
            // tab_ac
            $route:{
                handler(newVal, oldVal) {
                    console.log(newVal)
                    this.tab_ac=newVal.path.split('/')[1]
                    this.mobile_menu_open=false
            
                },
                immediate: true,
                deep: true
            },
		},
		created() {
			 
		},
        beforeDestroy() {
            this.restore_menu_scroll()
        },
		methods: {
            mobile_nav_icon(path) {
                return ({ '/home': 'el-icon-house', '/online': 'el-icon-chat-dot-round', '/comments_list': 'el-icon-document-checked', '/square_list': 'el-icon-office-building', '/enterprise_list': 'el-icon-suitcase', '/individual_list': 'el-icon-user', '/Classroom': 'el-icon-reading' })[path] || 'el-icon-menu'
            },
            restore_menu_scroll() {
                if (!this.menu_scroll_restore) return
                document.body.style.overflow = this.menu_scroll_restore.body
                document.documentElement.style.overflow = this.menu_scroll_restore.html
                this.menu_scroll_restore = null
            },
            handle_mobile_nav_click(event) {
                if (event.target.closest('a')) this.mobile_menu_open = false
            },
            trap_menu_focus(event) {
                if (!this.mobile_view || !this.mobile_menu_open) return
                const controls = Array.from(this.$el.querySelectorAll('.mobile_header button, .mobile_logo, .mobile_nav a, .mobile_nav summary'))
                    .filter(element => element.getClientRects().length)
                const first = controls[0]
                const last = controls[controls.length - 1]
                if (event.shiftKey && document.activeElement === first) {
                    event.preventDefault()
                    last.focus()
                } else if (!event.shiftKey && document.activeElement === last) {
                    event.preventDefault()
                    first.focus()
                }
            },
            close_mobile_menu(){
                this.mobile_menu_open=false
                this.$nextTick(() => this.$refs.mobile_menu_button && this.$refs.mobile_menu_button.focus())
            },
            handle_keyword(){
                this.$router.push({
                    path:'/square_list',
                    query:{
                        keyword:this.keyword
                    }
                })
            },
            // 会员中心点击
            handle_hyzx(e){
                console.log('会员中心点击',e)
                if(e.title=='退出登录'){
                    this.$confirm('是否退出?', '提示', {
                        confirmButtonText: '是',
                        cancelButtonText: '否',
                        type: 'warning'
                    }).then(() => {
					    this.$store.commit('clear_vuex_user',{})
                    }).catch(() => {
                                
                    });

                    
                }else{
                    this.$router.push({
                        path:e.path
                    })
                }
            },
            //快速发布
            handle_ksfb(e){
                console.log('快速发布点击',e)
                this.$router.push({
                    path:e.path
                })
            },
            //网站导航
            handle_wzdh(e){
                console.log('网站导航点击',e)
                this.$router.push({
                    path:e.path
                })
            },
            //底部跳转
            handle_path(item){
                console.log('底部跳转点击',item)
                this.$router.push({
                    path:item.path,
                })

            },
            //底部下拉跳转
            handle_tab(e){
                console.log('底部下拉跳转',e)
                this.$router.push({
                    path:e.path,
                })
            },
           
            handle_user(){
                this.$router.push({
                    path:'/user_grzx'
                })
            },
            handle_logo(){
                this.$router.push({
                    path:'/login'
                })
            },
            handle_enroll(){
                this.$router.push({
                    path:'/enroll'
                })
            },
            handle_home(){
                this.$router.push({
                    path:'/home'
                })
            },

		},
        

	}
</script>
<style scoped lang="less">
.index_header { 
    width: 100%;
    .header1_box{
        width: 100%;
        height: 40px;
        background: #F7F7F7;
        border-radius: 0px 0px 0px 0px;
        .header1{
            width: 1440px;
            height: 40px;
            margin: auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .lefts{
                display: flex;
                align-items: center;
                .l_text1{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #666666;
                    cursor: pointer;
                }
                .l_text2{
                    cursor: pointer;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #377CFD;
                    margin-left: 24px;
                }
            }
            .rights{
                display: flex;
                align-items: center;
                .r_text1{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #666666;
                    cursor: pointer;
                }
                .r_text2{
                    margin-left: 40px;
                    cursor: pointer;
                }
            }
        }
    }
    .header2_box{
        width: 100%;
        height: 134px;
        background: #FFFFFF;
        box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.1);
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        justify-content: center;
        .header2_top{
            width: 1440px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: auto;
            padding-top: 16px;
            .lefts{
                .logos{
                    width: 275px;
                    height: 64px;
                    img{
                        width: 275px;
                        height: 64px;
                        vertical-align: top;
                        cursor: pointer;
                    }
 
                }
            }
            .const{
                .seach_box{
                    width: 482px;
                    height: 40px;
                    background: #FFFFFF;
                    border-radius: 20px 20px 20px 20px;
                    border: 1px solid #377CFD;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .inputs{
                        flex: 1;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        input{
                            width: 100%;
                            padding: 0 24px;
                        }
                        input::placeholder{
                            color:#D7D7D7;

                        }   

                    }
                    .btns{
                        width: 124px;
                        height: 40px;
                        background: #377CFD;
                        border-radius: 0px 20px 20px 0px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;

                        img{
                            width:18px ;
                            height: 18px;
                            margin-right: 15px;
                        }
                    }

                }
            }
            .rights{
                // width: 400px;
                display: flex;
                align-items: center;
                .r_phones{
                    display: flex;
                    align-items: center;
                    .imgs{
                        width: 48px;
                        height: 48px;
                        img{
                            width: 48px;
                            height: 48px;
                        }
                    }
                    .r_text_box{
                        width: 200px;
                        height: 48px;
                        padding-left: 8px;
                        display: flex;
                        align-content: space-between;
                        flex-wrap: wrap;
                        .text1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-size: 14px;
                            color: #666666;
                        }
                        .text2{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 20px;
                            color: #377CFD;
                        }

                    }
                }
                .kf_btns{
                    width: 130px;
                    height: 40px;
                    background: #FFAA00;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #FFFFFF;
                    border-radius: 30px;
                    img{
                        width: 22px;
                        height: 22px;
                        margin-right: 11px;
                    }
                }
            }
        }
        .header2_bom{
            .header2{
                width: 1440px;
                margin: auto;
                display: flex;
                align-items: center;
                justify-content: space-between;
                // padding: 0 64px 0 34px ;
                .tab_list{
                    .borders{
                        margin: auto;
                        width: 32px;
                        height: 4px;
                        border-radius: 30px;
                        background: #FFFFFF;

                        margin-top: 10px;
                    }
                    .borders_ac{
                        background: #377CFD;

                    }
                    .tab_item1{
                        width: 70px;
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;
                        text-align: center;
                        &:hover{
                            color: #377CFD;
                            // font-weight: bold;
                            .borders{
                                background: #377CFD;
                            }
                        }   
                    }
                 
                    .tab_item2{
                        width: 100px;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        /deep/.el-dropdown{
                            .el-dropdown-link{
                                // text-align: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;
                                display:flex;
                                .el-icon-arrow-down{
                                    font-weight: bold;
                                }
                                // align-items: center;
                                &:hover{
                                    color: #377CFD;
                                    // font-weight: bold;
                                    .el-icon-arrow-down{
                                        color: #377CFD;
                                    }
                                    .borders{
                                        background: #377CFD;
                                    }
                                } 
                            }
                        }

                    }
                    .tab_item1_ac{
                        color: #377CFD;
                        // font-weight: bold;
                        .borders{
                            background: #377CFD;
                        }
                        /deep/.el-dropdown{
                            .el-dropdown-link{
                                color: #377CFD;
                                // font-weight: bold;
                                .el-icon-arrow-down{
                                    color: #377CFD;
                                }
                                .borders{
                                    background: #377CFD;
                                }
                            }
                        }
                    }
                  
                }
            }
        }
    }
    
}
</style>

<style scoped lang="less">
@media (max-width: 1024px) {
    .index_header.no-trans {
        position: relative;
        z-index: 1100;
        width: 100%;
        background: #fff;
        border-bottom: 1px solid #e9edf2;
        .header1_box, .header2_box { display: none; }
        .mobile_header { position: relative; z-index: 2; background: #fff; display: flex; align-items: center; gap: 8px; padding: 8px 20px; min-height: 64px; }
        .mobile_logo { flex: 1; min-width: 0; font-size: 18px; color: #273A8E; font-weight: bold; }
        .mobile_logo img { display: block; width: 210px; max-width: 100%; height: 48px; object-fit: contain; object-position: left center; }
        .mobile_user, .mobile_menu { width: 44px; height: 44px; flex-shrink: 0; background: transparent; color: #273A8E; font-size: 24px; cursor: pointer; }
        .mobile_nav_mask { position: fixed; inset: 0; z-index: 1; background: rgba(22, 32, 48, .38); }
        .mobile_nav { position: absolute; z-index: 2; top: 100%; left: 0; right: 0; background: #fff; padding: 4px 16px 8px; padding-bottom: max(8px, env(safe-area-inset-bottom)); max-height: ~"min(380px, 55vh)"; max-height: ~"min(380px, 55dvh)"; overflow-y: auto; overscroll-behavior: contain; border-top: 1px solid #e9edf2; border-radius: 0 0 8px 8px; box-shadow: 0 8px 20px rgba(22, 32, 48, .12); }
        .mobile_nav a, .mobile_nav summary { display: block; padding: 10px 8px; min-height: 44px; font-size: 14px; line-height: 24px; color: #333; border-bottom: 1px solid #f0f2f5; cursor: pointer; }
        .mobile_nav summary { display: list-item; margin-left: 16px; }
        .mobile_nav details a { padding-left: 28px; color: #666; }
        .mobile_nav a[aria-current="page"] { color: #377CFD; }
        .mobile_nav {
            padding: 10px 16px 12px;
            .mobile_nav_links { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }
            .mobile_nav_direct { display: flex; align-items: center; gap: 10px; min-width: 0; padding: 10px 12px; border: 0; border-radius: 4px; background: #f5f7fa; }
            .mobile_nav_direct:first-child { grid-column: ~"1 / -1"; }
            .mobile_nav_direct > i, summary > i:first-child { flex: 0 0 24px; font-size: 20px; color: #627b9e; }
            .mobile_nav_direct span, summary span { flex: 1; min-width: 0; overflow-wrap: anywhere; }
            details { grid-column: ~"1 / -1"; border-bottom: 1px solid #edf0f5; }
            summary { display: flex; align-items: center; gap: 10px; margin: 0; padding: 10px 12px; border: 0; list-style: none; font-weight: 500; }
            summary::-webkit-details-marker { display: none; }
            .nav_chevron { font-size: 14px; color: #8a98ab; transition: transform .18s; }
            details[open] .nav_chevron { transform: rotate(180deg); }
            .nav_group_active summary { color: #2468e8; }
            .nav_group_active summary > i:first-child { color: #377cfd; }
            .mobile_subnav { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 6px; padding: 0 8px 10px 46px; }
            details .mobile_subnav a { display: flex; align-items: center; justify-content: space-between; gap: 4px; min-width: 0; padding: 10px 8px; font-size: 13px; line-height: 24px; color: #657387; background: #f6f8fb; border: 0; border-radius: 4px; overflow-wrap: anywhere; }
            .mobile_subnav a i { flex: 0 0 12px; font-size: 12px; color: #9aa8ba; }
            a[aria-current="page"], details .mobile_subnav a[aria-current="page"] { color: #2468e8; background: #eaf1ff; font-weight: 600; }
            .mobile_nav_account { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; padding-top: 8px; border-top: 1px solid #e9edf2; }
            .mobile_nav_account a { display: flex; align-items: center; justify-content: center; gap: 8px; flex: 1; padding: 10px 12px; border: 0; color: #526681; font-size: 14px; }
            .mobile_nav_account a i { font-size: 18px; }
            a:focus-visible, summary:focus-visible { outline: 2px solid #377cfd; outline-offset: -2px; }
        }
    }
}
@media (max-width: 768px) {
    .index_header.no-trans .mobile_header { padding: 8px 16px; }
    .index_header.no-trans .mobile_logo img { width: 190px; height: 44px; }
}
</style>
